import {
  styled,
  Colors,
  rgba
} from '@unfold/theme';

import { Button } from '@unfold/button';
import loginHero from '../../assets/login.jpg';

export const LoginContainer = styled.div`
  position: relative;
  height: 100%;
  background-color: #000;
  color: ${Colors.WHITE};
  display: flex;
  font-family: 'Clarkson', Helvetica, Arial, sans-serif;}
`;

export const LogoWrapper = styled.div`
  position: absolute;
  top: 34px;
  left: 33px;
  svg > path {
    fill: ${Colors.WHITE};
  }
`;

export const TextSection = styled.section`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 50%;

  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const Subtitle = styled.h3`
  text-transform: uppercase;
  font-size: 13.5px;
  line-height: 17px;
  color: ${Colors.G300};
  font-weight: 500;
  letter-spacing: 1px;
  margin-top: 17px;
`;

export const Description = styled.span`
  color: ${Colors.G300};
  font-size: 14px;
  width: 200px;
  margin-top: 21px;
`;

export const LoginButton = styled(Button)`
  background-color: #000;
  color: #fff;
  border: 1px #fff solid;
  width: 205px;
  text-transform: none;
  transition: background-color .2s ease-in-out;
  margin: 20px 0;

  &:hover {
    background-color: #fff;
    color: #000;
  }
`;

export const LoginErrorMessage = styled.span`
  color: #FF7C7C;
  font-size: 12px;
  line-height: 16px;
`;

export const CTA = styled.span`
  color: ${Colors.WHITE};
  font-size: 14px;
`;

export const LoginImageSection = styled.section`
  display: flex;
  flex: 1;
  position: relative;

  @media (max-width: 600px) {
    display: none;
  }
`;

export const LoginImageDiv = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

export const LoginImage = styled(LoginImageDiv)`
  background-image: url('${loginHero}');
  background-size: cover;
  z-index: 1;
`;

export const LoginImageOverlay = styled(LoginImageDiv)`
  z-index: 2;
  background-color: ${rgba(Colors.BLACK, .25)};
`;
